// extracted by mini-css-extract-plugin
module.exports = {"grid":"Learn_grid__3Egxb","content":"Learn_content__h214W"};